(function(angular) {
    'use strict';

    /**
     * Init module
     */
    angular.module('wtApp.wtCommon', []);
})(window.angular);

